"use client";

import React from "react";
import { motion } from "framer-motion";

interface HeroContentProps {
  itemVariants: any;
}

export const HeroContent: React.FC<HeroContentProps> = ({ itemVariants }) => {
  return (
    <div className="flex flex-col items-center text-center max-w-5xl mx-auto px-4 z-10">
      {/* Main Heading (Poppins ExtraBold: 72px Desktop / 52px Tablet / 36px Mobile) */}
      <motion.div variants={itemVariants} className="w-full mb-7 sm:mb-8">
        <h1 className="font-heading font-extrabold tracking-tight text-white select-none drop-shadow-[0_4px_20px_rgba(0,0,0,0.35)]">
          <span className="block text-[36px] md:text-[52px] lg:text-[72px] leading-[1.02]">
            SHIVALIK
          </span>
          <span className="block text-[36px] md:text-[52px] lg:text-[72px] leading-[1.02] bg-gradient-to-r from-white via-white to-[#CBD5E1] bg-clip-text text-transparent">
            UNIVERSITY
          </span>
        </h1>
      </motion.div>

      {/* Tagline (University Crimson Red Palette) */}
      <motion.div variants={itemVariants} className="mb-7 sm:mb-8">
        <p className="font-sans font-semibold tracking-[0.25em] text-[#D72638] uppercase text-xs sm:text-sm bg-[#D72638]/10 border border-[#D72638]/25 px-4 py-1 rounded-full backdrop-blur-sm shadow-sm">
          Learn <span className="text-white/40 mx-2">•</span> Innovate <span className="text-white/40 mx-2">•</span> Build <span className="text-white/40 mx-2">•</span> Lead
        </p>
      </motion.div>

      {/* Authentic One-Sentence Description (Constrained to ~550px max width) */}
      <motion.div variants={itemVariants} className="max-w-[550px] mx-auto">
        <p className="font-sans text-sm sm:text-base md:text-[17px] text-[#CBD5E1] leading-relaxed font-normal select-none">
          Transforming knowledge into real-world impact through industry-focused education and innovation.
        </p>
      </motion.div>
    </div>
  );
};

export default HeroContent;
